import React from "react";
import Profile from "./components/Profile";

const App = () => <Profile />;

export default App;

